import type { Dexie } from "dexie";
import type { GroupEntry, ProductEntry } from "../types";

const hasProductIds = (group: GroupEntry) => Array.isArray(group.products_ids);

const productIdsByGroup = (products: ProductEntry[]) => {
	const buckets = new Map<string, Array<{ id: string; position: number }>>();

	for (const product of products) {
		for (const groupId of product.groups || []) {
			const list = buckets.get(groupId);
			const item = { id: product.id, position: product.position ?? 0 };
			if (list) list.push(item);
			else buckets.set(groupId, [item]);
		}
	}

	const result = new Map<string, string[]>();
	for (const [groupId, list] of buckets) {
		list.sort((a, b) => a.position - b.position);
		result.set(
			groupId,
			list.map((item) => item.id),
		);
	}

	return result;
};

export const migrateProductIds = async (vip: Dexie) => {
	const groups = await vip.table<GroupEntry>("groups").toArray();
	if (!groups.length || groups.every(hasProductIds)) return;

	const ids = productIdsByGroup(await vip.table<ProductEntry>("products").toArray());
	await vip.table("groups").bulkPut(groups.map((group) => ({ ...group, products_ids: ids.get(group.id) ?? [] })));
};
